import Icon from "components/icon";

export const ChatAvatar = defineComponent(() => {
  return () => {
    return (
      <div class="w-[72px] h-[72px] rounded-full bg-gradient-to-br from-primary-100 to-primary-50 ring-1 ring-primary-100 grid place-items-center overflow-hidden">
        <Icon
          size="1.5rem"
          fill="var(--color-primary-500)"
          src={async () => import("assets/img/svg/icons/ai-avatar.svg?raw")}
        />
      </div>
    );
  };
});
